import { WithKit } from 'api/User/types';
import KitIdInput from 'common/components/KitIdInput/KitIdInput';
import { useUpdateUserKit } from 'components/AdminDashboard/components/ShippingStatusPage/components/EditKitModal/hooks';

import { Box, Button, FormHelperText, Grid, Modal, Paper, Typography } from '@mui/material';
import React from 'react';
import { LoadingButton } from '@mui/lab';

interface Props {
  onCancel: () => void;
  onSave: (id: string, kitId: string) => void;
  withKit: WithKit;
}

const EditKitModal: React.FC<Props> = ({ onCancel, onSave, withKit }) => {
  const [ value, setValue ] = React.useState(withKit.kitId || '');

  const {
    requestUpdateUserKit,
    isLoading,
    error,
    setError,
  } = useUpdateUserKit(onSave);
  
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setError('');
    setValue(event.target.value);
  };

  const handleSave = () => {
    if (!value) {
      setError('Enter test kit id');
      return;
    }

    requestUpdateUserKit(withKit.id, value);
  };

  return (
    <Modal open>

      <Paper
        sx={{
          borderRadius: '20px',
          elevation: 9,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          outline: 'none',
          padding: 3,
          width: { xs: '100%', md: '600px' },
        }}
        data-testid="modal-edit-kit"
      >

        <Box>

          <Grid container spacing={3}>

            <Grid item xs={12}>
              <Typography variant="textXLBold">
                Enter test kit id
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <KitIdInput onChange={handleChange} disabled={isLoading} value={value} error={Boolean(error)} />

              {error && (
                <FormHelperText error data-testid="error-kit-length">
                  {error}
                </FormHelperText>
              )}
            </Grid>

            <Grid container spacing={2} item xs={12}>

              <Grid item>
                <LoadingButton variant="contained" onClick={handleSave} loading={isLoading} data-testid="button-save-kit-id">
                  Save
                </LoadingButton>
              </Grid>

              <Grid item>
                <Button variant="outlined" onClick={onCancel} disabled={isLoading}>
                  Cancel
                </Button>
              </Grid>

            </Grid>

          </Grid>

        </Box>

      </Paper>

    </Modal>
  );
};

export default EditKitModal;
